export default object => ({
  id: object.id,
  name: object.name,
  color: object.color,
});
